import Navbar from "./navbar";
import { Outlet } from "react-router-dom";

export default function Main() {
  return (
    <div>
      <div>
        <Navbar />
      </div>
      <Outlet />
    </div>
  );
}
